export default {
    HOTEL_VOUCHER: 'hotelvoucher',
    DIRECT_BOOKING: 'directbooking',
    VALUE_VOUCHER: 'valuevoucher',
    MULTI_VOUCHER: 'multivoucher'
};
